// ─────────────────────────────────────────────
//  TipSlider.jsx
//  Slider de porcentaje + botones de acceso rápido
//
//  RN migration:
//  • <input type="range"> → import Slider from '@react-native-community/slider'
//    <Slider minimumValue={5} maximumValue={50} step={1} value={value}
//            onValueChange={onChange} minimumTrackTintColor="#A8E6CF"
//            maximumTrackTintColor="rgba(255,255,255,0.1)" thumbTintColor="#fff" />
//  • Custom track fill → usar minimumTrackTintColor en Slider RN
//  • Quick buttons → <TouchableOpacity> con StyleSheet
// ─────────────────────────────────────────────

import React from 'react';
import styles from './TipSlider.module.css';
// import { formatCurrency } from '../utils/format';



export default function TipSlider({ value, onChange, min, max, quickTips, tipAmount }) {
	// Fill percentage for the custom track
	const fillPct = ((value - min) / (max - min)) * 100;


	return (
		<section className={styles.card} aria-label="Porcentaje de propina">

			{/* Header row */}
			<div className={styles.header}>
				<div>
					<p className={styles.label}>Propina</p>

					<p className={styles.pctDisplay} aria-live="polite">
						{value}<span className={styles.pctSign}>%</span>
					</p>
				</div>

				{/* <p className={styles.tipAmountSmall} aria-live="polite">
					{tipAmount !== null
						? <><strong>{formatCurrency(tipAmount)}</strong> de propina</>
						: '—'
					}
				</p> */}
				{/* <p className={styles.tipAmountSmall} aria-live="polite">
					Propina
				</p> */}
			</div>


			{/* Slider */}
			<div className={styles.trackWrap}>
				
				<div className={styles.trackBg}>
					<div className={styles.trackFill} style={{ width: `${fillPct}%` }} />
				</div>

				<input
					type="range"
					className={styles.slider}
					min={min}
					max={max}
					step={1}
					value={value}
					aria-label="Porcentaje de propina"
					aria-valuemin={min}
					aria-valuemax={max}
					aria-valuenow={value}
					aria-valuetext={`${value} por ciento`}
					onChange={(e) => onChange(Number(e.target.value))}
				/>
			</div>

			{/* Axis labels */}
			{/* <div className={styles.axisLabels} aria-hidden="true">
				<span>5%</span>
				<span>15%</span>
				<span>25%</span>
				<span>35%</span>
				<span>50%</span>
			</div> */}

			{/* Quick-access buttons */}
			<div
				className={styles.quickBtns}
				role="group"
				aria-label="Porcentajes de acceso rápido"
			>
				{quickTips.map((pct) => (
					<button
						key={pct}
						className={`${styles.quickBtn} ${value === pct ? styles.quickBtnActive : ''}`}
						onClick={() => onChange(pct)}
						aria-pressed={value === pct}
						aria-label={`${pct} por ciento`}
					>
						{pct}%
					</button>
				))}
			</div>

		</section>
	);
}
